
import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import StoryHero from './components/StoryHero';
import FounderStory from './components/FounderStory';
import HeritageSection from './components/HeritageSection';
import PhilosophySection from './components/PhilosophySection';
import SEOHead from '../../components/feature/SEOHead';

const BrandStoryPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "宫廷养森品牌故事 - 传承千年宫廷古方",
    "description": "探索宫廷养森的品牌历程，了解我们如何传承故宫千年古方智慧，融合现代中医验证技术",
    "author": {
      "@type": "Organization",
      "name": "宫廷养森"
    },
    "publisher": {
      "@type": "Organization",
      "name": "宫廷养森",
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/a9def463ca32930876b6ebe479fd9734.png"
      }
    },
    "datePublished": "2024-01-01",
    "dateModified": new Date().toISOString().split('T')[0],
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/brand-story`
    }
  };

  return (
    <>
      <SEOHead
        title="宫廷养森品牌故事 - 传承千年宫廷古方智慧"
        description="探索宫廷养森的品牌历程，了解我们如何传承故宫千年古方智慧，融合北京秘方传承中医医院现代中医验证技术，为您呈现内调外养的完整美丽解决方案。"
        keywords="宫廷养森品牌故事,故宫古方传承,中医养生历史,品牌理念,传统中医"
        path="/brand-story"
        schemaData={schemaData}
      />
      <div className={`min-h-screen transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`} style={{ backgroundColor: '#F8F4E9' }}>
        <Navigation />
        <main>
          <StoryHero />
          <FounderStory />
          <HeritageSection />
          <PhilosophySection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default BrandStoryPage;
